import React, { useEffect, useRef, useState } from "react";
import { coordenadas } from '../../store/actions/coordenadas';
import { useDispatch, useSelector } from 'react-redux';
import { meteorologicoNodo } from '../../store/actions/meteorologicoNodo';
import { sueloNodo } from '../../store/actions/sueloNodo';
import { riegoNodo } from '../../store/actions/riegoNodo';
import { entornoNodo } from '../../store/actions/entornoNodo';
import { aguaSaladaNodo } from '../../store/actions/aguaSaladaNodo';
import { aguaDulceNodo } from '../../store/actions/aguaDulceNodo';
import { teslaNodo } from '../../store/actions/teslaNodo';
import { Link } from 'react-router-dom';

import "mapbox-gl/dist/mapbox-gl.css";
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.js';

import '../home/map.css';
import '../home/styles.css';
import '../home/datosSensor.css';

import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';

mapboxgl.workerClass = class {
    constructor() {
        return new Worker(
            new URL('mapbox-gl/dist/mapbox-gl-csp-worker.js', import.meta.url),
            { type: 'module' }
        );
    }
};

const getGrafanaUrl = (item2) => {
    let id = 0;

    switch (item2) {
        case 'meteorologico':
            id = 4;
            break;
        case 'suelo':
            id = 6;
            break;
        case 'salada':
            id = 2;
            break;
        case 'riego':
            id = 5;
            break;
        case 'entorno':
            id = 3;
            break;
        case 'dulce':
            id = 1;
            break;
        case 'tesla':
            id = 7;
            break;
        default:
            id = 0;
            break;
    }

    const grafanaBase = "/d/";

    const dashboardUrls = {
        1: "fedgbzpsr0gsgb/dulce-mapa",
        2: "eedjjj7l2uygwb/salada-mapa",
        3: "cedggmhwhqf40e/entorno-mapa",
        4: "fedgit6rlohkwa/metorologico-mapa",
        5: "dedgk9ebooao0c/riego-mapa",
        6: "dedjj28lfgxdse/suelo-mapa",
        7: "tesla"
    };

    if (dashboardUrls[id]) {
        return `${grafanaBase}${dashboardUrls[id]}?orgId=1&from=now-6h&to=now&timezone=browser&theme=light&kiosk`;
    }

    return grafanaBase;
};

const Map3D = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const pointsEventsRegistered = useRef(false);

    const dispatch = useDispatch();

    const Coordenadas = useSelector(state => state.coordenadas);

    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingResultados, setIsLoadingResultados] = useState(false);
    const [resultadosMeteorologicos, setResultadosMeteorologicos] = useState([]);
    const [mapLoaded, setMapLoaded] = useState(false);

    useEffect(() => {
        if (isLoading) {
            dispatch(coordenadas(Coordenadas)).finally(() => {
                setIsLoading(false);
                setIsLoadingResultados(true);
            });
        }
    }, [dispatch, Coordenadas, isLoading]);

    useEffect(() => {
        const eliminarDuplicados = (lista) => {
            const seen = new Set();
            const uniqueList = [];

            lista.forEach(item => {
                if (!item.item1 || item.item1.length === 0) return;

                const item1Key = item.item1
                    .map(obj => `${obj.lat},${obj.lon}`)
                    .sort()
                    .join('|');

                const coordKey = `${item1Key}|${item.item2}`;

                if (!seen.has(coordKey)) {
                    seen.add(coordKey);
                    uniqueList.push(item);
                }
            });

            return uniqueList;
        };

        const fetchMeteorologico = async () => {
            if (!isLoadingResultados) return;
            if (!Coordenadas?.current || !Array.isArray(Coordenadas.current)) return;

            try {
                const resultadosTemporales = [];

                const promises = Coordenadas.current.map(async (coord) => {
                    const { lat, lon } = coord;

                    const tipos = [
                        teslaNodo,
                        meteorologicoNodo,
                        sueloNodo,
                        riegoNodo,
                        entornoNodo,
                        aguaSaladaNodo,
                        aguaDulceNodo,
                    ];

                    for (const accion of tipos) {
                        try {
                            const res = await dispatch(accion({ lat, lon }));

                            if (res.payload && res.payload[0] != null && res.payload[0].length > 0) {
                                resultadosTemporales.push({
                                    item1: res.payload[0],
                                    item2: res.payload[1] || null
                                });
                            }
                        } catch (error) {
                            console.error(`Error al obtener datos para ${lat}, ${lon}:`, error);
                        }
                    }
                });

                await Promise.all(promises);

                setResultadosMeteorologicos(eliminarDuplicados(resultadosTemporales));
            } finally {
                setIsLoadingResultados(false);
            }
        };

        fetchMeteorologico();
    }, [dispatch, isLoadingResultados, Coordenadas]);

    useEffect(() => {
        mapboxgl.accessToken = "pk.eyJ1IjoibWF0dXB2IiwiYSI6ImNtMWhxYXVqYzBpcXAybHFsYm5yNnE3ZmMifQ.MrjouJnOqqGGLKM4k9aphw";

        if (map.current) return;

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/satellite-streets-v12",
            center: [-0.229812, 38.985349],
            zoom: 6,
            pitch: 60,
            bearing: -20,
            antialias: true
        });

        map.current.on("load", () => {
            if (!map.current.getSource("mapbox-dem")) {
                map.current.addSource("mapbox-dem", {
                    type: "raster-dem",
                    url: "mapbox://mapbox.terrain-rgb",
                    tileSize: 512,
                    maxzoom: 14
                });
            }

            map.current.setTerrain({
                source: "mapbox-dem",
                exaggeration: 1.5
            });

            map.current.addControl(new mapboxgl.NavigationControl(), "top-right");
            map.current.addControl(new mapboxgl.FullscreenControl());

            map.current.setFog({
                range: [0.5, 10],
                color: "rgba(186, 210, 235, 0.5)",
                "horizon-blend": 0.2
            });

            setMapLoaded(true);
        });

        return () => {
            if (map.current) {
                map.current.remove();
                map.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (!mapLoaded) return;
        if (!map.current) return;
        if (!resultadosMeteorologicos || resultadosMeteorologicos.length === 0) return;

        const geojson = {
            type: "FeatureCollection",
            features: resultadosMeteorologicos
                .filter(element =>
                    element.item1 &&
                    element.item1[0] &&
                    element.item1[0].lat &&
                    element.item1[0].lon
                )
                .map((element, index) => ({
                    type: "Feature",
                    id: index,
                    geometry: {
                        type: "Point",
                        coordinates: [
                            parseFloat(element.item1[0].lon),
                            parseFloat(element.item1[0].lat)
                        ]
                    },
                    properties: {
                        id: element.item2,
                        name: "Nodo multiparamétrico"
                    }
                }))
        };

        if (map.current.getSource("points")) {
            map.current.getSource("points").setData(geojson);
        } else {
            map.current.addSource("points", {
                type: "geojson",
                data: geojson
            });

            map.current.addLayer({
                id: "points",
                type: "circle",
                source: "points",
                paint: {
                    "circle-color": "#4264fb",
                    "circle-radius": 8,
                    "circle-stroke-width": 2,
                    "circle-stroke-color": "#ffffff"
                }
            });
        }

        if (!pointsEventsRegistered.current) {
            map.current.on("click", "points", (e) => {
                const clickedFeature = e.features[0];
                const grafanaUrl = getGrafanaUrl(clickedFeature.properties.id);

                new mapboxgl.Popup({ maxWidth: "none" })
                    .setLngLat(clickedFeature.geometry.coordinates)
                    .setHTML(`
                        <div style="width: 60vh; height: 60vh;">
                            <h3>Nodo multiparamétrico</h3>
                            <iframe src="${grafanaUrl}" width="100%" height="90%" frameborder="0"></iframe>
                        </div>
                    `)
                    .addTo(map.current);
            });

            map.current.on("mouseenter", "points", () => {
                map.current.getCanvas().style.cursor = "pointer";
            });

            map.current.on("mouseleave", "points", () => {
                map.current.getCanvas().style.cursor = "";
            });

            pointsEventsRegistered.current = true;
        }
    }, [mapLoaded, resultadosMeteorologicos]);

    return (
        <>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a className="navbar-brand ps-3" href="index.html">Multiparametric sensor</a>
                <form className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0"></form>
            </nav>

            <div id="layoutSidenav">
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu"></div>
                        <div className="sb-sidenav-footer">
                            <div className="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>

                <div id="layoutSidenav_content" className="flex-grow-1">
                    <div
                        ref={mapContainer}
                        style={{
                            width: "100%",
                            height: "100%",
                            position: "relative"
                        }}
                    />
                </div>

                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Options</div>
                                <Link id="link" to="/">
                                    <button type="button" id="link" className="btn btn-light">
                                        <div className="sb-nav-link-icon">
                                            <i className="fas fa-tachometer-alt"></i>
                                        </div>
                                        Back
                                    </button>
                                </Link>
                            </div>
                        </div>

                        <div className="sb-sidenav-footer">
                            <div className="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>
            </div>
        </>
    );
};

export default Map3D;